const nameSuffixes = [
    {
      value: '',
      label: ''
    },
    {
      value: 'junior',
      label: 'Jr.'
    },
    {
      value: 'senior',
      label: 'Sr.'
    },
    {
      value: 'third',
      label: 'III'
    },
    {
      value: 'fourth',
      label: 'IV'
    },
    {
      value: 'fifth',
      label: 'V'
    }
  ],
  citizenshipStatuses = [
    {
      value: '',
      label: ''
    },
    {
      value: 'us_citizen',
      label: 'US Citizen'
    },
    {
      value: 'permanent_resident_alien',
      label: 'Permanent Resident Alien'
    },
    {
      value: 'non_resident_alien',
      label: 'Non-resident Alien'
    },
    {
      value: 'h1_visa_holder',
      label: 'H1 Visa Holder'
    },
    {
      value: 'e2_visa_holder',
      label: 'E2 Visa Holder'
    },
    {
      value: 'e3_visa_holder',
      label: 'E3 Visa Holder'
    },
    {
      value: 'l1_visa_holder',
      label: 'L1 Visa Holder'
    },
    {
      value: 'j1_visa_holder',
      label: 'J1 Visa Holder'
    },
    {
      value: 'other',
      label: 'Other'
    }
  ],
  graduateFields = [
    {
      value: '',
      label: ''
    },
    {
      value: 'mba',
      label: 'MBA'
    },
    {
      value: 'law',
      label: 'Law'
    },
    {
      value: 'medicine',
      label: 'Medicine'
    },
    {
      value: 'optometry',
      label: 'Optometry'
    },
    {
      value: 'dentistry',
      label: 'Dentistry'
    },
    {
      value: 'nursing',
      label: 'Nursing'
    },
    {
      value: 'physician_assistant',
      label: 'Physician Assistant'
    },
    {
      value: 'healthcare_administration',
      label: 'Healthcare Administration'
    },
    {
      value: 'pharmacy',
      label: 'Pharmacy'
    },
    {
      value: 'finance_not_mba',
      label: 'Finance (not MBA)'
    },
    {
      value: 'accounting',
      label: 'Accounting'
    },
    {
      value: 'engineering',
      label: 'Engineering'
    },
    {
      value: 'computer_science',
      label: 'Computer Science'
    },
    {
      value: 'public_policy',
      label: 'Public Policy'
    },
    {
      value: 'real_estate',
      label: 'Real Estate'
    },
    {
      value: 'veterinary',
      label: 'Veterinary'
    },
    {
      value: 'science',
      label: 'Science'
    },
    {
      value: 'other',
      label: 'Other'
    }
  ],
  graduateFieldsPrimary = [
    {
      value: '',
      label: ''
    },
    {
      value: 'mba',
      label: 'MBA'
    },
    {
      value: 'law',
      label: 'Law'
    },
    {
      value: 'medicine_do',
      label: 'Medicine - DO'
    },
    {
      value: 'medicine_md',
      label: 'Medicine - MD'
    },
    {
      value: 'optometry',
      label: 'Optometry'
    },
    {
      value: 'dentistry_dds',
      label: 'Dentistry - DDS'
    },
    {
      value: 'dentistry_dmd',
      label: 'Dentistry - DMD'
    },
    {
      value: 'nursing',
      label: 'Nursing'
    },
    {
      value: 'physician_assistant',
      label: 'Physician Assistant'
    },
    {
      value: 'healthcare_administration',
      label: 'Healthcare Administration'
    },
    {
      value: 'pharmacy',
      label: 'Pharmacy'
    },
    {
      value: 'finance_not_mba',
      label: 'Finance (not MBA)'
    },
    {
      value: 'accounting',
      label: 'Accounting'
    },
    {
      value: 'engineering',
      label: 'Engineering'
    },
    {
      value: 'computer_science',
      label: 'Computer Science'
    },
    {
      value: 'public_policy',
      label: 'Public Policy'
    },
    {
      value: 'real_estate',
      label: 'Real Estate'
    },
    {
      value: 'veterinary',
      label: 'Veterinary'
    },
    {
      value: 'science',
      label: 'Science'
    },
    {
      value: 'podiatry',
      label: 'Podiatry'
    },
    {
      value: 'occupational_therapy',
      label: 'Occupational Therapy'
    },
    {
      value: 'physical_therapy',
      label: 'Physical Therapy – MPT or DPT'
    },
    {
      value: 'other',
      label: 'Other'
    }
  ],
  graduateFieldsTopOptions = [
    {
      value: 'mba',
      label: 'MBA'
    },
    {
      value: 'law',
      label: 'Law'
    },
    {
      value: 'medicine',
      label: 'Medicine'
    },
    {
      value: 'nursing',
      label: 'Nursing'
    }
  ],
  graduateFieldsTopOptionsPrimary = [
    {
      value: 'mba',
      label: 'MBA'
    },
    {
      value: 'law',
      label: 'Law'
    },
    {
      value: 'medicine_do',
      label: 'Medicine - DO'
    },
    {
      value: 'medicine_md',
      label: 'Medicine - MD'
    },
    {
      value: 'nursing',
      label: 'Nursing'
    },
    {
      value: 'pharmacy',
      label: 'Pharmacy'
    }
  ],
  graduateFieldsOtherOptions = [
    {
      value: 'pharmacy',
      label: 'Pharmacy'
    },
    {
      value: 'science',
      label: 'Science'
    },
    {
      value: 'physician_assistant',
      label: 'Physician Assistant'
    },
    {
      value: 'engineering',
      label: 'Engineering'
    },
    {
      value: 'dentistry',
      label: 'Dentistry'
    },
    {
      value: 'accounting',
      label: 'Accounting'
    },
    {
      value: 'computer_science',
      label: 'Computer Science'
    },
    {
      value: 'healthcare_administration',
      label: 'Healthcare Administration'
    },
    {
      value: 'public_policy',
      label: 'Public Policy'
    },
    {
      value: 'veterinary',
      label: 'Veterinary'
    },
    {
      value: 'optometry',
      label: 'Optometry'
    },
    {
      value: 'finance_not_mba',
      label: 'Finance (not MBA)'
    },
    {
      value: 'real_estate',
      label: 'Real Estate'
    },
    {
      value: 'other',
      label: 'Other'
    }
  ],
  graduateFieldsOtherOptionsPrimary = [
    {
      value: 'science',
      label: 'Science'
    },
    {
      value: 'physician_assistant',
      label: 'Physician Assistant'
    },
    {
      value: 'engineering',
      label: 'Engineering'
    },
    {
      value: 'dentistry_dds',
      label: 'Dentistry - DDS'
    },
    {
      value: 'dentistry_dmd',
      label: 'Dentistry - DMD'
    },
    {
      value: 'accounting',
      label: 'Accounting'
    },
    {
      value: 'computer_science',
      label: 'Computer Science'
    },
    {
      value: 'healthcare_administration',
      label: 'Healthcare Administration'
    },
    {
      value: 'public_policy',
      label: 'Public Policy'
    },
    {
      value: 'veterinary',
      label: 'Veterinary'
    },
    {
      value: 'optometry',
      label: 'Optometry'
    },
    {
      value: 'finance_not_mba',
      label: 'Finance (not MBA)'
    },
    {
      value: 'real_estate',
      label: 'Real Estate'
    },
    {
      value: 'podiatry',
      label: 'Podiatry'
    },
    {
      value: 'occupational_therapy',
      label: 'Occupational Therapy'
    },
    {
      value: 'physical_therapy',
      label: 'Physical Therapy – MPT or DPT'
    },
    {
      value: 'other',
      label: 'Other'
    }
  ],
  states = [
    { value: 'AL', label: 'Alabama' },
    { value: 'AK', label: 'Alaska' },
    { value: 'AZ', label: 'Arizona' },
    { value: 'AR', label: 'Arkansas' },
    { value: 'CA', label: 'California' },
    { value: 'CO', label: 'Colorado' },
    { value: 'CT', label: 'Connecticut' },
    { value: 'DE', label: 'Delaware' },
    { value: 'DC', label: 'District of Columbia' },
    { value: 'FL', label: 'Florida' },
    { value: 'GA', label: 'Georgia' },
    { value: 'HI', label: 'Hawaii' },
    { value: 'ID', label: 'Idaho' },
    { value: 'IL', label: 'Illinois' },
    { value: 'IN', label: 'Indiana' },
    { value: 'IA', label: 'Iowa' },
    { value: 'KS', label: 'Kansas' },
    { value: 'KY', label: 'Kentucky' },
    { value: 'LA', label: 'Louisiana' },
    { value: 'ME', label: 'Maine' },
    { value: 'MD', label: 'Maryland' },
    { value: 'MA', label: 'Massachusetts' },
    { value: 'MI', label: 'Michigan' },
    { value: 'MN', label: 'Minnesota' },
    { value: 'MS', label: 'Mississippi' },
    { value: 'MO', label: 'Missouri' },
    { value: 'MT', label: 'Montana' },
    { value: 'NE', label: 'Nebraska' },
    { value: 'NV', label: 'Nevada' },
    { value: 'NH', label: 'New Hampshire' },
    { value: 'NJ', label: 'New Jersey' },
    { value: 'NM', label: 'New Mexico' },
    { value: 'NY', label: 'New York' },
    { value: 'NC', label: 'North Carolina' },
    { value: 'ND', label: 'North Dakota' },
    { value: 'OH', label: 'Ohio' },
    { value: 'OK', label: 'Oklahoma' },
    { value: 'OR', label: 'Oregon' },
    { value: 'PA', label: 'Pennsylvania' },
    { value: 'RI', label: 'Rhode Island' },
    { value: 'SC', label: 'South Carolina' },
    { value: 'SD', label: 'South Dakota' },
    { value: 'TN', label: 'Tennessee' },
    { value: 'TX', label: 'Texas' },
    { value: 'UT', label: 'Utah' },
    { value: 'VT', label: 'Vermont' },
    { value: 'VA', label: 'Virginia' },
    { value: 'WA', label: 'Washington' },
    { value: 'WV', label: 'West Virginia' },
    { value: 'WI', label: 'Wisconsin' },
    { value: 'WY', label: 'Wyoming' }
  ]

export {
  nameSuffixes,
  citizenshipStatuses,
  graduateFields,
  graduateFieldsPrimary,
  graduateFieldsTopOptions,
  graduateFieldsTopOptionsPrimary,
  graduateFieldsOtherOptions,
  graduateFieldsOtherOptionsPrimary,
  states
}
